<template>
  <!-- 待阅卷列表 -->
  <div class="paperTestAudit_main">
    <van-nav-bar :title="'待阅卷'"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 :fixed="true" />
    <div class="content">
      <van-search v-model="searchTxt"
                  shape="round"
                  placeholder="请输入搜索关键词"
                  @input="onSearch" />
      <van-list v-model="loading"
                class="process_list"
                :finished="finished"
                :finished-text="$t('toEvaluated.evaluateTxt3')"
                @load="onLoad">
        <van-cell v-for="(item,idx) in processList"
                  class="process_box"
                  :key="'Audit'+idx"
                  @click="goToAudit(item)">
          <div class="list_no">
            {{$t('trainRecordsDetails.TrdTxt3')}}{{item.listno}}
          </div>
          <div class="list_va">
            <div class="up">
              <div class="papername">
                <div class="title">
                  <img src="@/assets/img/examRecord_1.png"
                       alt="" />
                  {{ item.papername }}
                </div>
                <div class="score">
                  {{ item.score }}
                  <span>{{$t('toEvaluated.evaluateTxt8')}}</span>
                </div>
              </div>
              <div class="others">
                <div class="label">{{$t('examRecord.ErTxt4')}}</div>
                <div class="val">{{ item.coursetype }}</div>
              </div>
              <div class="others">
                <div class="label">{{$t('examRecord.ErTxt5')}}</div>
                <div class="val">{{ item.totalscore }}</div>
              </div>
              <div class="others">
                <div class="label">{{'课程名称：'}}</div>
                <div class="val">{{ item.coursename }}</div>
              </div>
            </div>
            <div class="down">
              <div class="label">{{$t('examRecord.ErTxt6')}}</div>
              <div class="val">{{ item.et }}</div>
              <van-tag :type="item.teststyle =='补考'?'danger':'warning'">{{ item.teststyle }}</van-tag>
            </div>
          </div>
        </van-cell>
      </van-list>
    </div>
    <van-popup v-model="showAudit"
               :close-on-click-overlay="false"
               class="paperTestAudit_by_login">
      <PaperTest v-if="showAudit"
                 :autoid="autoid"
                 :mautoid="mautoid"
                 :empid="empid"
                 :paperid="paperid"
                 :teststyle="teststyle"
                 :ispass="ispass"
                 :hasyj="hasyj"
                 :username='username'
                 :hasLogin="true"
                 @refreshData='onLoad'
                 @getBack="getBack"></PaperTest>
    </van-popup>
  </div>
</template>

<script>
import { getForYjPaperList } from "@api/wxpx.js";
import PaperTest from '@/views/ssoPaperTestAudit/paperTest.vue'
export default {
  components: {
    PaperTest
  },
  data () {
    const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
    return {
      userInfo,
      loading: false,
      finished: false,
      searchTxt: '',
      initProcess: [],
      processList: [],
      showAudit: false,
      paperid: 0,
      mautoid: 0,
      autoid: 0,
      empid: 0,
      teststyle: '',
      ispass: false,
      hasyj: false,
    }
  },
  methods: {
    // 返回
    onClickLeft () {
      // if (this.$route.query.from == 'home')
      // {
      this.$router.push('/home')
      // } else
      // {
      //   this.$router.push('/personCen')
      // }
    },
    // 搜索
    onSearch () {
      if (this.searchTxt)
      {
        this.processList = this.initProcess.filter(
          item =>
            item.papername.indexOf(this.searchTxt) > -1 ||
            item.coursename.indexOf(this.searchTxt) > -1 ||
            item.coursetype.indexOf(this.searchTxt) > -1 ||
            item.teststyle.indexOf(this.searchTxt) > -1
        )
      } else
      {
        this.processList = this.initProcess
      }
    },
    // 查询
    onLoad () {
      this.getForYjPaperListData()
    },
    // 获取流程委托信息
    getForYjPaperListData () {
      this.loading = true
      getForYjPaperList({
        empid: this.userInfo.empid
      }).then(res => {
        this.initProcess = JSON.parse(JSON.stringify(res.data))
        this.processList = res.data
        this.loading = false;
        this.finished = true;
      })
    },
    goToAudit (item) {
      this.mautoid = item.mautoid
      this.username = this.userInfo.username
      this.paperid = item.paperid
      this.autoid = item.pmid
      this.empid = item.empid
      this.teststyle = item.teststyle
      this.ispass = item.ispass
      this.hasyj = item.hasyj
      this.showAudit = true
    },
    getBack () {
      this.showAudit = false
    }
  }
}
</script>

<style lang="less" scoped>
.paperTestAudit_main {
  height: 100vh;
  overflow: hidden;
  .paperTestAudit_by_login {
    height: 100%;
    width: 100%;
  }
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    /deep/.van-nav-bar__right {
      font-size: 28px;
      .van-nav-bar__text {
        color: #fff;
      }
    }
  }
  .content {
    // overflow: auto;
    margin-top: 1.22667rem;
    height: calc(100% - 92px);
    .van-search {
      height: 112px;
    }
    .process_list {
      // margin-top: 20px;
      height: calc(100% - 112px);
      overflow-y: auto;
      .process_box {
        padding: 0 !important;
        margin-bottom: 28px;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);
        .van-cell__value {
          .list_no {
            padding: 0 20px;
            margin-bottom: 20px;
            font-size: 24px;
            color: #666666;
            line-height: 64px;
            word-break: break-all;
            background: linear-gradient(
              90deg,
              rgba(25, 137, 250, 0) 0%,
              rgba(25, 137, 250, 0.5) 0%,
              rgba(25, 137, 250, 0) 100%
            );
          }
          .list_va {
            padding: 0 20px;
          }
          .up {
            position: relative;
            font-family: Source Han Sans CN;
            border-bottom: 2px solid #ccc;
            font-size: 28px;
            color: #999;
            // padding-bottom: 22px;
            .papername {
              display: flex;
              align-items: center;
              justify-content: space-between;
              border-bottom: 2px solid #ccc;
              padding-bottom: 10px;
              .title {
                font-size: 32px;
                color: #333333;
                line-height: 54px;
                font-weight: bold;
              }
              .score {
                display: flex;
                align-items: baseline;
                font-size: 40px;
                font-family: DIN;
                font-weight: bold;
                span {
                  font-size: 28px;
                }
              }
            }
            .others {
              display: flex;
              padding: 8px 0;
              .label {
                width: 30%;
                font-size: 28px;
                color: #666666;
              }
              .val {
                flex: 1;
                text-align: left;
                font-size: 28px;
                color: #333333;
              }
            }
          }
          .down {
            display: flex;
            align-items: center;
            height: 78px;
            color: #666666;
            .label {
              width: 30%;
              font-size: 28px;
              color: #666666;
            }
            .val {
              flex: 1;
              text-align: left;
              font-size: 28px;
              color: #fba433;
            }
          }
        }
      }
    }
  }
}
</style>